<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      gap: 8px;
      justify-content: stretch;
      align-items: stretch;
    ">
    <v-switch
      @change="togglePreferCueTake"
      direction="vertical"
      v-model="autoCueTake"
      color="primary"
      inset
      hide-details></v-switch>
    <div
      style="
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex-grow: 1;
        margin: 0px 8px;
      "
      class="interact-btn-outer">
      <div
        style="
          display: flex;
          justify-content: center;
          border-radius: 5px;
          cursor: pointer;
          height: 100%;
          background: var(--v-cardColor-base);
        "
        @click="handleTake()"
        class="pa-1 subtleshadow">
        <div
          :style="
            cuedDid
              ? 'background: var(--primary-color); color:white!important'
              : ''
          "
          class="interact-btn">
          <v-progress-circular
            v-if="takeLoading"
            indeterminate
            :size="20"
            :width="2"
            color="white"></v-progress-circular>

          <v-icon
            v-else
            style="opacity: 0.8"
            size="large">
            mdi-chevron-double-right
          </v-icon>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onBeforeMount, watch, computed } from 'vue';
import { $http } from '../../stores/http.js';
import { deluge } from '@/stores/deluge.js';
import { state } from '../../stores/deluge.js';

const autoCueTake = ref(false);
const takeLoading = ref(false);

const props = defineProps({
  takeAll: {
    type: Boolean,
    default: false,
  },
  frameNo: {
    type: Number,
    default: null,
  },
});

const effectiveFrame = computed(() => props.frameNo ?? state.selected_frame);

// Compute the cued DID for the currently selected frame
const cuedDid = computed(() => {
  if (!effectiveFrame.value) return null;
  return deluge.new_cued_dids?.[effectiveFrame.value] || null;
});

async function togglePreferCueTake() {
  await $http('PUT', '/dynamic_engine/toggle_prefer_cue');
}

onBeforeMount(() => {
  autoCueTake.value = deluge.config?.extra_info?.prefer_cue;
});

watch(
  () => deluge.config?.extra_info?.prefer_cue,
  (val) => {
    autoCueTake.value = val;
  }
);
async function handleTake() {
  takeLoading.value = true;
  if (props.takeAll) {
    try {
      await $http('GET', '/dynamic_engine/take/all');
    } catch (e) {
      console.log(e);
    }
  } else {
    try {
      await $http(
        'POST',
        `/dynamic_engine/take/channel/${
          deluge.channels[deluge.frames[effectiveFrame.value].did].uid
        }`
      );
    } catch (e) {
      console.log(e);
    }
  }

  takeLoading.value = false;
}
</script>
<style scoped>
.interact-btn {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease-in;
}
.interact-btn:hover {
  opacity: 0.8;
  background: var(--primary-color);
  color: white !important;
}
.interact-btn:active {
  opacity: 1;
  background: var(--primary-color);
  color: white !important;
}
</style>
